import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "isCombined", "isInline"];
import * as React from 'react';
import cn from 'classnames';
import { ControlAppearanceType, ControlShapeType } from '../../../library/index';
import { Pane } from '../../pane';
import { buttonClasses } from './button';
export var ButtonGroupContext = React.createContext({});
export var Buttons = function Buttons(props) {
  var children = props.children,
    className = props.className,
    isCombined = props.isCombined,
    isInline = props.isInline,
    paneProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(buttonClasses.GROUP, {
    '-combined': props.isCombined,
    '-inline': props.isInline
  }, props.className);
  return React.createElement(Pane, _extends({
    margin: props.margin,
    padding: props.padding,
    className: classNames
  }, paneProps), React.createElement(ButtonGroupContext.Provider, {
    value: {
      appearance: props.appearance,
      density: props.density,
      shape: props.shape,
      size: props.size,
      isDisabled: props.isDisabled,
      isSquare: props.isSquare
    }
  }, props.children));
};
Buttons.displayName = 'Buttons';
Buttons.defaultProps = {
  isInline: false,
  isCombined: false,
  isDisabled: false,
  shape: ControlShapeType.ROUNDED,
  appearance: ControlAppearanceType.FILL
};